export default __webpack_public_path__ + "static/media/cui.106958e2.jpg";